import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-client-structure',
  templateUrl: './client-structure.component.html',
  styleUrls: ['./client-structure.component.scss']
})
export class ClientStructureComponent {
  // Detecta si el dispositivo es móvil
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  opened: boolean = true;

  constructor(private router: Router, private breakpointObserver: BreakpointObserver, private authService: AuthService) { }
  getUserInitials(): string {
    let dataUser = this.authService.getUserData();
    const names = dataUser.data_user.name.split(" ");
    const initials = names[0][0] + (names[1] ? names[1][0] : '');
    return initials.toUpperCase();
  }

  changePassword() {
    // Lógica para cambiar la clave
  }

  logout() {
    // Lógica para cerrar sesión
    Swal.fire({
      title: '¿Estás seguro que deseas cerrar sesión?',
      text: "",
      showCancelButton: true,
      confirmButtonColor: '#1C37BA',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Cerrar sesión',
      showClass: {
        popup: `
      animate__animated
      animate__fadeInUp
      animate__faster
    `,
      },
    }).then((option) => {
      if (option.isConfirmed) {
        this.authService.logout();
      }
    });
  }
}
